var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.table.headers,"items":_vm.table.items,"items-per-page":15},scopedSlots:_vm._u([{key:"item.program",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.kodeProgram)+" - "+_vm._s(item.namaProgram)+" ")]}},{key:"item.kegiatan",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.kode)+" - "+_vm._s(item.nama)+" ")]}},{key:"item.pagu",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getNumberSep(item.pagu))+" ")]}},{key:"item.paguTerpakai",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getNumberSep(item.paguTerpakai))+" ")]}},{key:"item.paguSisa",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getNumberSep(item.pagu - item.paguTerpakai))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }